module.exports = __webpack_public_path__ + "images/issue-num.37166a7ab1eafe5105d78dd14d58a7ca.png";